import "./Partners.module.css";
import Header from "@/reusable_sections/Header";
import ThreeStepApproachCta from "./sections/ThreeStepApproachCta";
import Benefits from "./sections/Benefits";
import Solution from "./sections/Solution";
import IncreaseYourRevenue from "./sections/IncreaseYourRevenue";
import OurModels from "./sections/OurModels";
import WordHost from "./sections/WordHost";
import NeemContactOp from "./sections/NeemContactOp";
import VoltGoFooter from "@/reusable_sections/Footer";
export default function PartnersPage() {
  return <div>
      <Header />
      <ThreeStepApproachCta />
      <Benefits />
      <Solution />
      <IncreaseYourRevenue />
      <OurModels />
      <WordHost />
      <NeemContactOp />
      <VoltGoFooter />
    </div>;
}